import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iConfirmPassiveUserState {
    email: string;
    isLoading: boolean;
    response: any;
    message: string;
}

const initialState: iConfirmPassiveUserState = {
    email: '',
    isLoading: false,
    response: [],
    message: ""
}
export const postConfirmPassiveUserAPI = createAsyncThunk(
    'POST_CONFIRM_NO_ACTIVE_USER',
    async (user: { email: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/deactivate-user/'
            
            const response = await axiosInstance.patch(
                `${djangoEndpoint}${pathParam}`,
                {
                    email: user.email,
                },
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const confirmPassiveUserSlice = createSlice({
    name: 'confirmNoActiveUser',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postConfirmPassiveUserAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postConfirmPassiveUserAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postConfirmPassiveUserAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.email = '';
                state.response = action.payload;
            });
    }
});

export default confirmPassiveUserSlice.reducer;